export enum ComponentType {
    Address = 'address',
    AiFaces = 'ai-faces',
    Boolean = 'boolean',
    ComplexList = 'complex-list',
    Date = 'date',
    Edtf = 'edtf',
    Enum = 'enum',
    Frames = 'frames',
    Jdn = 'jan-de-nul',
    LabeledUrl = 'labeled-url',
    List = 'list',
    MultiItem = 'multi-item',
    MapField = 'map-field',
    Number = 'number',
    Permissions = 'permissions',
    Tags = 'tags',
    Text = 'text',
    TextArea = 'text-area',
    Url = 'url',
    TimeCode = 'time-code',
    Thesaurus = 'thesaurus',
    WebserviceList = 'webservice-list'
}
